import { of, Observable } from 'rxjs';

/**
 * Workaround service that expose { of } from 'rxjs' for e2e mocks.
 */
export type IObservableOf = (any) => Observable<any>;

export const ObservableOfProvider: {
  provide: string;
  useValue: IObservableOf;
} = {
  provide: 'observableOf',
  useValue: of,
};
